import { useState, useEffect } from 'react';

const FeaturedArticles = () => {
  const [featuredPosts, setFeaturedPosts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // あなたのドメインに書き換えてください
    const domain = 'https://mm.ai-adult.org'; 
    // 最新の3件を「注目記事」として取得する例
    const wpUrl = `${domain}/wp-json/wp/v2/posts?_embed&per_page=3`;

    fetch(wpUrl)
      .then((res) => res.json())
      .then((data) => {
        const formatted = data.map((post: any) => ({
          id: post.id,
          title: post.title.rendered,
          // WordPressのアイキャッチ画像を取得
          image: post._embedded?.['wp:featuredmedia']?.[0]?.source_url || '代替画像のURL',
          excerpt: post.excerpt.rendered.replace(/<[^>]+>/g, '').substring(0, 100) + '...',
          date: new Date(post.date).toLocaleDateString('ja-JP'),
          link: post.link,
          category: post._embedded?.['wp:term']?.[0]?.[0]?.name || '注目'
        }));
        setFeaturedPosts(formatted);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return null; // 読み込み中は何も表示しない、またはスケルトンを表示

  // 1番目の記事を大きく、残りを横に並べるなどのレイアウトは今のデザインに合わせて調整してください
  const mainPost = featuredPosts[0];
  const sidePosts = featuredPosts.slice(1);

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold mb-10 text-center">注目記事</h2>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* メインの大きな記事 */}
          {mainPost && (
            <div className="lg:col-span-8">
              <div className="relative h-[500px] rounded-2xl overflow-hidden group">
                <img src={mainPost.image} alt="" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent p-8 flex flex-col justify-end">
                  <span className="bg-teal-500 text-white px-3 py-1 rounded-full text-sm w-fit mb-4">{mainPost.category}</span>
                  <h3 className="text-white text-3xl font-bold mb-4" dangerouslySetInnerHTML={{ __html: mainPost.title }} />
                  <a href={mainPost.link} className="text-white font-medium hover:underline">記事を読む →</a>
                </div>
              </div>
            </div>
          )}
          {/* サイドの小さな記事 */}
          <div className="lg:col-span-4 flex flex-col gap-8">
            {sidePosts.map((post) => (
              <div key={post.id} className="bg-white rounded-xl overflow-hidden shadow-sm flex h-[230px]">
                <img src={post.image} alt="" className="w-1/3 object-cover" />
                <div className="p-4 flex flex-col justify-center w-2/3">
                  <h4 className="font-bold text-lg mb-2 line-clamp-2" dangerouslySetInnerHTML={{ __html: post.title }} />
                  <a href={post.link} className="text-teal-500 text-sm font-medium">詳しく見る</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedArticles;